export default __webpack_public_path__ + "static/media/WaveyFingerprint.b3f83e47.svg";